import LandingRoutes from "./LandingRoutes.js";

const App = () => <LandingRoutes />;

export default App;
